(function () {
  var STORAGE_KEY = 'sbrx_geo_ca_v1';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var apiKey = window.__SBRX_IPAPI_KEY__;
  if (!apiKey) return;

  var els = document.querySelectorAll('.ingredients-ca-warning[data-geo-ca]');
  if (!els.length) return;

  function showCa() {
    for (var i = 0; i < els.length; i++) els[i].removeAttribute('hidden');
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || typeof o.ca !== 'boolean' || typeof o.t !== 'number') return null;
      if (Date.now() - o.t > TTL_MS) return null;
      return o.ca;
    } catch (e) {
      return null;
    }
  }

  function writeCache(ca) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ca: !!ca, t: Date.now() }));
    } catch (e) {}
  }

  var cached = readCache();
  if (cached !== null) {
    if (cached) showCa();
    return;
  }

  var url = 'https://ipapi.co/json/?key=' + encodeURIComponent(apiKey);
  fetch(url)
    .then(function (r) {
      return r.json();
    })
    .then(function (data) {
      if (!data || data.error) return;
      var ca = data.country_code === 'US' && data.region_code === 'CA';
      writeCache(ca);
      if (ca) showCa();
    })
    .catch(function () {});
})();
